import { Location } from '@angular/common';
import { Component, HostBinding, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../service/api/api.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  param = { value: 'world' };

  @HostBinding('class.c-app') cAppClass = true;

  // Nouveau design de sidebar ("Sceau") activé par défaut ; repasser à false
  // pour retrouver l'ancien sidebar (conservé intact ci-dessous, au cas où).
  public use_sidebar_sceau = true;

  public navItems: any[] = [];
  public navItems_translated: any[] = [];

  public perfectScrollbarConfig = {
    suppressScrollX: true,
  };

  constructor(public api: ApiService, private route: Router, public location: Location, private translate: TranslateService) {

  }
  async ngOnInit() {
    console.log("initialisation de HomeComponent")
    let show_sidebar = await this.api.get_from_local_storage("show_sidebar")
    this.api.show_sidebar = show_sidebar == null ? true : show_sidebar

    // Le menu est déjà calculé (custom_menu()) juste après la connexion ou par
    // AuthGuard : on l'affiche immédiatement au lieu d'attendre le rafraîchissement
    // réseau ci-dessous, qui ne fait que resynchroniser les droits en arrière-plan.
    this.build_nav_items();

    this.api.get_privilege(() => {
      this.build_nav_items();
    });
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.build_nav_items();
    });
  }

  private build_nav_items() {
    this.navItems_translated = this.api.menu.map((one_item: any) => {
      one_item.name = this.translate.instant(one_item.name)
      if (one_item.children?.length) {
        one_item.children = one_item.children.map((child: any) => ({
          ...child,
          name: this.translate.instant(child.name)
        }))
      }
      return one_item
    })
    this.refresh_badges_menu();
  }

  // ── Badge "action en attente" sur le sidebar ──────────────────────────────
  // Percepteur : OR/ASP générés par la mairie, en attente de sa décision.
  // Mairie : OR retournés par la perception, pas encore corrigés.
  private refresh_badges_menu() {
    const categorie = (this.api.infos?.current_mairie?.categorie || '').toLowerCase();

    if (categorie === 'perception' || categorie === 'tresor') {
      this.api.taf_post_object('apurement/count_or_attente', {}, (res: any) => {
        this.set_badge_menu('/home/ordre-recette', res?.data?.nb_total_attente || 0);
      }, () => { });
    }

    if (categorie === 'mairie') {
      this.api.taf_post_object('apurement/count_or_a_corriger', {}, (res: any) => {
        this.set_badge_menu('/home/apurement', res?.data?.nb_a_corriger || 0);
      }, () => { });
    }
  }

  private set_badge_menu(url: string, count: number) {
    const item = this.navItems_translated.find((i: any) => i.url === url);
    if (!item) return;
    item.badge = count > 0 ? { color: 'danger', text: String(count), class: 'nav-badge-alert' } : undefined;
    this.navItems_translated = [...this.navItems_translated];
  }
}
